// Suppliers Mutations

export const updateSuppliersList = (state, payload) => {
  state.suppliersList = payload
}

export const fetchSupplierInfo = (state, payload) => {
  state.supplierInfo = payload
}

export const setFullVendersList = (state, payload) => {
  state.fullVendersList = payload
}
